import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import ProfileAvatarLg from "./ProfileAvatarLg";
import ProfileAvatar from "./ProfileAvatar";
import "./Profile.css";
import EditProfile from "./EditProfile";
import ProfileComponent from "./ProfileComponent";
import Language from "./Language";
import ManagePassword from "./ManagePassword";
import ManageProfile from "./ManageProfile";
import { useCurrentRole } from "../../_helper/constant/Permission";
import { useUploadfile } from "../../_helper/actions/mutation/image";
import { useSecureUpdateItem } from "../../_helper/actions/mutation/items";
import { toast } from "react-toastify";

export default function Profile() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { role_name, role_id } = useCurrentRole();
  const [formData, setFormData] = useState({});
  const option = searchParams.get("option");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [clinic] = useAtom(clinicAtom);

  const filter = `?action=getDoctorPersonalDetails&clinic_id=${clinic?.id}&backend=True&login=True`;

  const { data, isLoading } = useItemsFilter(
    `${ApiEndPoint.USERS}doctor_personal_detail/`,
    filter,
    clinic ? true : false
  );
  // //("dataaaaaaaaaaa", data);
  // //("role name", role_name);
  useEffect(() => {
    if (data) {
      setFormData(data);
    }
  }, [data, setFormData]);

  // //("profile image--------", formData?.profile_img);

  const uploadProfilemutation = useUploadfile();
  const editProfileMutation = useSecureUpdateItem(
    `${ApiEndPoint.USERS}doctor_personal_detail/`
  );

  const handleUploadProfile = (e) => {
    const formdata = new FormData();
    formdata.append("files", e.target.files[0]);
    formdata.append("upload_to", "staff");
    formdata.append("staff_id", role_id);
    uploadProfilemutation.mutate(formdata, {
      onSuccess: (data) => {
        //("data-------", data[0]?.url);
        const payload = {
          action: "patchLoginDoctorDetails",
          backend: "True",
          clinic_id: clinic?.id,
          profile_img: data[0]?.url,
        };
        editProfileMutation.mutate(
          { data: payload },
          {
            onSuccess: () => {
              toast.success("Profile updated successfully");
            },
            onError: () => {
              toast.error("Something went wrong!");
            },
          }
        );
      },
      onError: () => {
        toast.error("Something went wrong!");
      },
    });
  };

  return (
    <div className="profile-container mt-10 p-0 lg:px-10 lg:py-5">
      <div className="ml-8">
        <div className="absolute cursor-pointer" onClick={() => navigate(-1)}>
          <IoMdArrowBack size={28} />
        </div>
        <div className="profile-avatar-lg">
          <ProfileAvatarLg
            full_name={`${data?.first_name} ${data?.last_name}`}
            phone={data?.phone_number}
            img={formData?.profile_img}
            role_name={role_name}
            onProfilePhoto={handleUploadProfile}
            isLoading={
              uploadProfilemutation.isLoading || editProfileMutation.isLoading
            }
            deleteProfile={() => setOpenDeleteModal(true)}
          />
        </div>
      </div>
      <div className="profile-avatar">
        <ProfileAvatar
          full_name={`${data?.first_name} ${data?.last_name}`}
          phone={data?.phone_number}
          img={formData?.profile_img}
          role_name={role_name}
          onProfilePhoto={handleUploadProfile}
          deleteProfile={() => setOpenDeleteModal(true)}
          isLoading={
            uploadProfilemutation.isLoading || editProfileMutation.isLoading
          }
        />
      </div>
      <div className="flex-1 lg:mt-0 mt-8">
        {!option && <ProfileComponent />}
        {option === "edit-profile" && (
          <EditProfile
            data={data}
            setFormData={setFormData}
            formData={formData}
            setOpenDeleteModal={setOpenDeleteModal}
            openDeleteModal={openDeleteModal}
          />
        )}
        {option === "manage-profile" && <ManageProfile />}
        {option === "manage-password" && <ManagePassword />}
        {option === "language" && <Language />}
      </div>
    </div>
  );
}
